
Greenmile.Task = Greenmile.Task || {};

Greenmile.Task.SuggestedServiceWindow = function (modelAttributes, locationSuggested, actualLocation) {

    Greenmile.Task.Suggested.apply(this, arguments);

    const taskId = modelAttributes.id;
    const classMainContainer = 'suggestedServiceWindow';
    const classContainerToContent = `${classMainContainer}__content`;
    const classSuggestedTimeWindow = 'suggestedTimeWindow';
    const classTimeWindowActual = 'timeWindowActual';
    const checkIfErrorOccured = { error : false };

    const buildContainerToServiceTimes = (containerToContent) => {
        const container = document.createElement('div');
        container.setAttribute('id', `${classMainContainer}__serviceTimes`);
        containerToContent.appendChild(container);

        return container;
    };

    const showAllContent = (section, containerToContent) => {
        section.appendChild(containerToContent);
    };

    const buildServiceTimesContent = (serviceTimesContainer, actualTimeWindow) => {
        const timeWindowSuggested = selectTimeWindowSuggested();

        const timeWindowActual = buildTimeWindow(actualTimeWindow, classTimeWindowActual, 'Task.TimeWindowActual.label');
        const suggestedTimeWindow = buildTimeWindow(timeWindowSuggested, classSuggestedTimeWindow, 'Task.SuggestedTimeWindow.label');

        serviceTimesContainer.appendChild(timeWindowActual);
        serviceTimesContainer.appendChild(suggestedTimeWindow);
    };

    const selectTimeWindowSuggested = () => {
        const timeWindowSuggested = locationSuggested && locationSuggested.timeWindow;
        if(timeWindowSuggested && timeWindowSuggested.length) {
            return timeWindowSuggested;
        } else {
            console.error('No TimeWindow suggested provided.');
            checkIfErrorOccured.error = true;
            return [];
        }
    };

    const buildTimeWindow = (timeWindowToBuild, classMainContainer) => {
        const timeWindow = this.buildContainerToContent(classMainContainer);

        const labelContainer = this.buildContainerToContent(`${classMainContainer}__label`);
        labelContainer.innerHTML = this.getResourceTo(`Task.${classMainContainer}.label`);

        const datesAndTimesContainer = this.buildContainerToContent(`${classMainContainer}__datesAndTimes`);

        const datesAndTimesContainerWithContent = document.createDocumentFragment();
        timeWindowToBuild.forEach( timeWindow => {
            datesAndTimesContainerWithContent.appendChild(buildDatesWeekAndTimes(classMainContainer, timeWindow));
        });
        
        if(!timeWindowToBuild.length) {
            const msgNoTimeWindow = this.buildContainerToContent(`${classMainContainer}__msgNoTimeWindow`);
            msgNoTimeWindow.innerHTML = this.getResourceTo(`Task.${classMainContainer}.msgNoTimeWindow`);
            datesAndTimesContainerWithContent.appendChild(msgNoTimeWindow);
        }

        datesAndTimesContainer.appendChild(datesAndTimesContainerWithContent);

        timeWindow.appendChild(labelContainer);
        timeWindow.appendChild(datesAndTimesContainer);

        return timeWindow;
    };

    const buildDatesWeekAndTimes = (classMainContainer, timeWindow) => {

        const dateWeekAndTime = this.buildContainerToContent(`${classMainContainer}__dateWeekAndTime`);

        const timeWindowWeekDays = this.buildContainerToContent(`${classMainContainer}__dates`);
        const timeWindowTimesOpenClose = this.buildContainerToContent(`${classMainContainer}__timesOpenClose`);
        const timeWindowTimeWindow = this.buildContainerToContent(`${classMainContainer}__timeWindow`);

        timeWindowWeekDays.innerHTML = buildWeekDateString(timeWindow);
        timeWindowTimesOpenClose.innerHTML = buildTimesOpenCloseString(timeWindow);
        timeWindowTimeWindow.innerHTML = buildTimesToTimeWindowString(timeWindow);

        dateWeekAndTime.appendChild(timeWindowWeekDays);
        dateWeekAndTime.appendChild(timeWindowTimesOpenClose);
        dateWeekAndTime.appendChild(timeWindowTimeWindow);

        return dateWeekAndTime;
    };

    const buildWeekDateString = (timeWindow) => {
        const weekDays = [
            { key: 'sunday', value: this.getResourceTo('weekdays.sunday')},
            { key: 'monday', value: this.getResourceTo('weekdays.monday')},
            { key: 'tuesday', value: this.getResourceTo('weekdays.tuesday')},
            { key: 'wednesday', value: this.getResourceTo('weekdays.wednesday')},
            { key: 'thursday', value: this.getResourceTo('weekdays.thursday')},
            { key: 'friday', value: this.getResourceTo('weekdays.friday')},
            { key: 'saturday', value: this.getResourceTo('weekdays.saturday')} 
        ];

        const weekDaysToRender = weekDays.map( day => {
            if(timeWindow[day.key]) {
                return `<b>${day.value.substr(0, 3)}</b>`;
            } else {
                return day.value.substr(0, 3);
            }
        });

        return weekDaysToRender.join(' | ');
    };

    const buildTimesOpenCloseString = (timeWindow) => {
        const text = this.getResourceTo('Task.SuggestedServiceWindow.label.TimesOpenClose');
        return `${text}: ${timeWindow.openTime} - ${timeWindow.closeTime}`;
    };

    const buildTimesToTimeWindowString = (timeWindow) => {
        const text = this.getResourceTo('Task.SuggestedServiceWindow.label.TimeWindow');
        const timeWindow2 = timeWindow.tw2Open ? `| ${timeWindow.tw2Open} - ${timeWindow.tw2Close}` : '';
        return `${text}: ${timeWindow.tw1Open} - ${timeWindow.tw1Close} ${timeWindow2}`;
    }; 

    const callbackAction = (typeAction) => {
        return () => {
            let timeWindow = null;
            if(typeAction === this.pathActions.accept) {
                timeWindow = document.querySelector(`.${classMainContainer} .${classTimeWindowActual}`);
            } else if(typeAction === this.pathActions.decline) {
                timeWindow = document.querySelector(`.${classMainContainer} .${classSuggestedTimeWindow}`);
            }

            timeWindow && timeWindow.classList.add("mutted");
        }   
    };

    this.handleAlreadyDone = (typeAction) => {
        !checkIfErrorOccured.error && this.disableButtonsHandler();
        (modelAttributes.userChangeTaskFormStatus && this.showWhoAndWhen(modelAttributes, classMainContainer, typeAction));
        return callbackAction(typeAction);
    };

    this.disableButtonsHandler =  this.disableButtonsTo(classMainContainer);

    const handleIfOccuredSomeError = (section) => {
        checkIfErrorOccured.error && section.remove();
    };

    const fetchActualTimeWindow = (actualLocation, section) => {
        const locationCollection = App.Objects.Location.collection;
        const criteria = { 'filters': ['locationOverrideTimeWindows.*'] };
        const filter = {
            "eq": actualLocation.id,
            "attr": "id"
        };
        toggleShowLoading();
        locationCollection.filterWithRestrictions({
            criteria: JSON.stringify(criteria),
            filter: filter,
            success: (data) => {
                console.log('sucesso');
                toggleShowLoading();
                renderAllContent(data, section);
            },
            error: (error) => {
                new Monet.Exception.ReturnError(this,
                    'Error try get actual timeWindow ')
                    .console();
            }
        });
    };

    const setActualTimeWindow = (data) => {
        const locationAttributes = data && data.models && data.models.map( model => model.attributes );
        const locationOverrideTimeWindows =  locationAttributes && locationAttributes.filter( attributes => attributes.locationOverrideTimeWindows );
        const locationOverrideTimeWindowsList =  locationOverrideTimeWindows && locationOverrideTimeWindows.flatMap( attributes => attributes.locationOverrideTimeWindows );

        if(locationOverrideTimeWindowsList && locationOverrideTimeWindowsList.length) {
           return [...locationOverrideTimeWindowsList];
        } else {
            console.log('No TimeWindow to actual Location.');
            return [];
        }

    };

    const toggleShowLoading = () => {
        const classLoadingContainer = `${classMainContainer}__loading`;
        const loadingContainer = document.querySelector(`#Task .MonetUIForm .${classLoadingContainer}`);
        if(loadingContainer) {
            loadingContainer.remove();
        } else {
            const container = this.buildContainerToContent(classLoadingContainer);
            const image = require("static/images/general/loading_blue.svg");
            container.innerHTML = '<img src="' + image + '" style="width: 40px">';
            this.getSection(classMainContainer).appendChild(container);
        }
    };

    const renderAllContent = (data, section) => {
        const actualTimeWindow =  setActualTimeWindow(data);
        const containerToContent = this.buildContainerToContent(classContainerToContent);
        const serviceTimesContainer = buildContainerToServiceTimes(containerToContent);

        buildServiceTimesContent(serviceTimesContainer, actualTimeWindow);
        this.buildButtons(containerToContent, taskId);
        showAllContent(section, containerToContent);
        handleIfOccuredSomeError(section);
        this.checkSuggestionAlreadyDone(modelAttributes.taskFormStatus);
    };

    this.render = () => {
        const section = this.buildSection('Task.SuggestedServiceWindow.title.section', classMainContainer);
        fetchActualTimeWindow(actualLocation, section);
    };

    return this;
};